import { motion } from "framer-motion";
import { ASSETS, CONTACT } from "@/data/assets";
import { useLang } from "@/i18n/LanguageContext";
import { reveal } from "@/hooks/reveal";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-black/60 border-t border-white/10" data-testid="site-footer">
      <motion.div {...reveal()} className="max-w-[1500px] mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-2 gap-10 items-start">
          <div>
            <div className="flex items-center gap-3">
              <img src={ASSETS.logo} alt="AlloLabs UK" className="h-11 w-auto object-contain" />
              <span className="font-display font-extrabold tracking-tight text-lg text-white">
                AlloLabs <span className="text-[var(--al-gold)]">UK</span>
              </span>
            </div>
            <p className="font-body text-white/45 text-sm leading-relaxed mt-5 max-w-md">
              {t.footer.tagline}
            </p>
          </div>
          <div className="md:text-right">
            <div className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-white/40">{t.footer.contactLabel}</div>
            <p className="font-body text-white/80 text-sm md:text-base mt-3 leading-relaxed">
              {t.footer.hotlinePrefix} {CONTACT.phone}
              <br />
              {t.footer.deskPrefix}{" "}
              <a href={`mailto:${CONTACT.email}`} className="text-[var(--al-gold)] gold-underline break-all">
                {CONTACT.email}
              </a>
            </p>
          </div>
        </div>

        {/* Legal disclaimer — fixed, bold */}
        <div className="mt-14 border-t border-white/10 pt-8">
          <p className="font-body font-bold text-white/70 text-[12px] md:text-[13px] leading-relaxed" data-testid="legal-disclaimer">
            {t.footer.disclaimer}
          </p>
        </div>

        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-white/30">
            © {new Date().getFullYear()} AlloLabs UK — {t.footer.rights}
          </span>
          <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-[var(--al-gold)]/60">
            {t.footer.ruoLine}
          </span>
        </div>
      </motion.div>
    </footer>
  );
};
